import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable React error overlay for cross-origin and third-party script errors
if (typeof window !== 'undefined') {
  // Suppress console.error for specific third-party errors
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args.map(a => String(a)).join(' ');
    // Suppress cross-origin errors from PostHog/analytics/PayPal
    if (message.includes('cross-origin') || 
        message.includes('removeEventListener') ||
        message.includes('SecurityError') ||
        message.includes('posthog') ||
        message.includes('Script error') ||
        message.includes('zoid') ||
        message.includes('paypal')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };

  // Suppress window.onerror
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    const msg = String(message || '');
    const src = String(source || '');
    if (msg.includes('cross-origin') || 
        msg.includes('removeEventListener') ||
        msg.includes('SecurityError') ||
        msg.includes('Script error') ||
        src.includes('posthog') ||
        src.includes('paypal')) {
      return true;
    }
    if (originalOnError) {
      return originalOnError.apply(this, arguments);
    }
    return false;
  };

  // Intercept error events
  window.addEventListener('error', (event) => {
    const msg = event.message || '';
    const src = event.filename || '';
    if (msg.includes('cross-origin') || 
        msg.includes('removeEventListener') ||
        msg.includes('SecurityError') ||
        msg.includes('Script error') ||
        src.includes('posthog') ||
        src.includes('paypal')) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, true);
  
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || String(event.reason || '');
    if (reason.includes('cross-origin') || 
        reason.includes('SecurityError') ||
        reason.includes('zoid')) {
      event.preventDefault();
    }
  });

  // Aggressively hide error overlays that may be from third-party scripts
  const hideErrorOverlays = () => {
    // React error overlay
    const overlays = document.querySelectorAll('iframe[style*="z-index"], div[style*="z-index: 2147483647"]');
    overlays.forEach(overlay => {
      if (overlay.tagName === 'IFRAME') {
        try {
          const doc = overlay.contentDocument || overlay.contentWindow?.document;
          const text = doc?.body?.textContent || '';
          if (text.includes('cross-origin') || text.includes('removeEventListener') || text.includes('Script error')) {
            overlay.style.display = 'none';
          }
        } catch (e) {
          // Cross-origin iframe, can't access
        }
      }
    });
    
    // Create-react-app error overlay
    const reactOverlay = document.getElementById('webpack-dev-server-client-overlay');
    if (reactOverlay) {
      const text = reactOverlay.textContent || '';
      if (text.includes('cross-origin') || text.includes('Script error')) {
        reactOverlay.style.display = 'none';
      }
    }
  };
  
  // Check periodically and on DOM changes
  setInterval(hideErrorOverlays, 200);
  const observer = new MutationObserver(hideErrorOverlays);
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
